export default window.matchMedia != null &&
    window.matchMedia('(pointer: coarse)').matches;
